import React, { useEffect, useState } from "react";
import AjoDashboardPreview from "./features/AjoDashboardPreview";
import FeaturesLeftPanel from "./features/FeaturesLeftPanel";
import FeaturesTabs from "./features/FeaturesTabs";
import {
  DashboardIcon,
  SavingsIcon,
  ajoModules,
  iconBase,
  leftPanelContent,
  previewData,
  rowIcons,
} from "./features/config";

export default function Features() {
  const [activeId, setActiveId] = useState("overview");
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return undefined;
    const moduleIds = ajoModules.map((m) => m.id);
    let currentIndex = moduleIds.indexOf(activeId);
    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % moduleIds.length;
      setActiveId(moduleIds[currentIndex]);
    }, 4000);
    return () => clearInterval(interval);
  }, [activeId, isAutoPlaying]);

  const preview = previewData[activeId] || previewData.overview;
  const activeModule =
    ajoModules.find((m) => m.id === activeId) ||
    ajoModules.find((m) => m.id === "overview") || {
      icon: DashboardIcon,
      color: "#6C63FF",
      title: "Overview",
    };
  const content = leftPanelContent[activeId] || leftPanelContent.overview;

  return (
    <section className="relative overflow-hidden py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8"  style={{ backgroundColor: '#F8FAFC' }}>
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-indigo-200/30 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 bottom-10 h-72 w-72 rounded-full bg-emerald-200/20 blur-3xl" />
      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6">
        <div className="mb-10 text-center"> 
          <h1 className="text-2xl font-medium text-gray-900 sm:text-4xl lg:text-5xl">
          Explore <span className="text-gray-600">What Ajo can do</span>
          </h1>
          <p className="mx-auto max-w-[600px] text-[1.1rem] leading-7 text-slate-500">
            Secure transactions, transparent operations, and easy access to your savings anytime, anywhere.
          </p>
        </div>

        <FeaturesTabs
          modules={ajoModules}
          activeId={activeId}
          iconBase={iconBase}
          setActiveId={setActiveId}
          setIsAutoPlaying={setIsAutoPlaying}
        />

        <div className="flex flex-col items-start gap-8 lg:flex-row lg:gap-12">
          <FeaturesLeftPanel activeModule={activeModule} content={content} />

          <div className="w-full min-w-0 lg:flex-1">
            <AjoDashboardPreview
              preview={preview}
                activeColor={activeModule.color}
              rowIcons={rowIcons}
              fallbackRowIcon={SavingsIcon}
            />
          </div>
        </div>

      </div>
    </section>
  );
}
